// import {Box,Typography} from '@mui/material'

import { Facebook, Instagram } from "@mui/icons-material"
import { Alert, Button, Grid, Link, Stack, TextField, Typography } from "@mui/material"
import { border, Container } from "@mui/system"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { addToWaitlist } from "../../state/slices/waitlist"
import validateEmail from "../../utils/emailValidator"

// TikTok Icon Component
const TikTokIcon = ({ style }) => (
    <svg
        viewBox="0 0 24 24"
        style={{ width: 24, height: 24, ...style }}
        fill="currentColor"
    >
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </svg>
)

function Waitlist() {
    const { t } = useTranslation();
    let waitlistState = useSelector(state => state.waitlist)
    let dispatch = useDispatch()

    let [email, setEmail] = useState('')
    let [error, setError] = useState('')

    let emailChangeHandler = (e) => {
        setEmail(e.target.value)

        if (!e.target.value) {
            setError(t('waitlist.emailCannotBeBlank'))
        }
        else if (!validateEmail(e.target.value)) {
            setError(t('waitlist.invalidEmail'))
        } else {
            setError('')
        }
    }

    let addToWaitlistHandler = () => {
        if (!email) {
            setError(t('waitlist.emailCannotBeBlank'))
        }
        else if (!validateEmail(email)) {
            setError(t('waitlist.invalidEmail'))
        } else {
            setError('')
            dispatch(addToWaitlist({ email }))
            // setEmail('')
        }
    }
    return (
        <div>

            <Stack ml={2} direction={'row'} justifyContent='start'>
                {/* <Typography color='rgb(66, 135, 245)' fontWeight={600} fontSize={40}>Astegne</Typography> */}
            </Stack>
            <Container >

                <Grid justifyContent={'center'} container spacing={2}>
                    <Grid item order={{ xs: 2, md: 1 }} xs={12} lg={5} md={6}>
                        <Stack height={'100%'} spacing={2} justifyContent='center'>
                            {/* <Typography textAlign={{ xs: 'center', md: 'left' }} variant="h3" fontWeight={600} color={'rgb(66, 135, 245)'}>See what's next</Typography> */}
                            <Typography textAlign={{ xs: 'center', md: 'left' }} color='primary' variant="h3" fontWeight={800}>{t('waitlist.title')}</Typography>
                            <Typography textAlign={{ xs: 'center', md: 'left' }} variant='h6' color='grey'>{t('waitlist.subtitle')}</Typography>
                            {
                                !waitlistState.successMsg &&
                                <Stack direction={{ sx: 'column', md: 'row' }} gap={2}>
                                    <TextField
                                        sx={{ borderBottom: 'none' }}
                                        variant="outlined"
                                        placeholder={t('waitlist.email')}
                                        inputProps={{
                                            style: {
                                                height: "5px",
                                                border: 'none',
                                                // background: 'rgb(235, 232, 232)'
                                            },
                                        }}

                                        onChange={emailChangeHandler}
                                        value={email}
                                        error={Boolean(error)}
                                        helperText={error}
                                    />
                                    <Button onClick={addToWaitlistHandler} disableElevation={true}
                                        sx={{ textTransform: 'capitalize', height: '37px', width: 'auto', bgcolor: "primary" }}
                                        disabled={waitlistState.loading}
                                        size='' variant="contained"
                                    >
                                        {waitlistState.loading ? t('waitlist.joining') : t('waitlist.joinWaitlist')}
                                    </Button>
                                </Stack>
                            }
                            {
                                waitlistState.errorMsg ?
                                    <Alert severity="info">{waitlistState.errorMsg}</Alert>
                                    : waitlistState.successMsg ?
                                        <Alert severity="success">{waitlistState.successMsg}</Alert>
                                        : <></>

                            }
                        </Stack>
                    </Grid>
                    <Grid item order={{ xs: 1, md: 2 }} xs={12} md={4}>
                        <Stack height={{ xs: '40vh', md: '80vh' }} direction={'row'} sx={{ my: 1, justifyContent: 'center', overflow: 'hidden' }}>
                            <img style={{ height: '80vh', width: '100vw', objectFit: 'contain' }} src={'/pFrame.png'} ></img>
                        </Stack>
                    </Grid>
                </Grid>
                <Stack mt={2} rowGap={2} direction='column' justifyContent='center' alignItems='center'>
                    <Stack direction='row' gap={2} >
                        <Link target={'_blank'} href="https://www.instagram.com/astegneapp/?igshid=MzRlODBiNWFlZA==" underline="none">
                            <Instagram style={{ color: 'gray' }}></Instagram>
                        </Link>
                        <Link target={'_blank'} href="https://www.facebook.com/profile.php?id=100092570389153&mibextid=LQQJ4d" underline="none">
                            <Facebook style={{ color: 'gray' }}></Facebook>
                        </Link>
                        <Link target={'_blank'} href="https://www.tiktok.com/@astegne" underline="none">
                            <TikTokIcon style={{ color: 'gray' }} />
                        </Link>
                    </Stack>
                    <Typography color='gray'>© {new Date().getFullYear()} Astegne. {t('footer.allRightsReserved')}. {t('common.addisAbabaEthiopia')}. </Typography>
                </Stack>
            </Container>
        </div>
    )
}

export default Waitlist